import { createComponent } from '../BaseComponent';
import { TooltipProps } from './interface';

export const Tooltip = createComponent<TooltipProps>('Tooltip', 'tooltip', null, true);
